// Bridge AngularJS (`UmsApp`) services UP into Angular DI — the mirror of downgrades.ts
// (which bridges Angular code DOWN into AngularJS). Every ng1 service that Angular code needs
// is exposed here via an InjectionToken whose factory pulls it from the upgraded `$injector`
// (provided by @angular/upgrade's UpgradeModule). Consumers `inject(TOKEN)`.
//
// All ng1→ng2 bridges live in this one file; `UPGRADE_PROVIDERS` is spread into AppModule's
// providers so they're registered once. Add a new bridge = one token + one `fromNg1(...)`.
import { InjectionToken } from '@angular/core';
import type { Provider } from '@angular/core';
import { _pb } from '../_module';

// AngularJS `md5` service — secret-key.interceptor hashes with it to match the legacy header.
export const NG1_MD5 = new InjectionToken<any>('ng1.md5');
// AngularJS `$uibModal` (ui-bootstrap) — Angular components open the still-ng1 modals through it.
export const NG1_UIB_MODAL = new InjectionToken<any>('ng1.$uibModal');
// App-wide template-base path (`/app/`). NOT an ng1 service — a build constant from _module.ts
// (also injected as the ambient `_pb` global by ProvidePlugin). Exposed as a token so Angular
// code injects it instead of reaching for the global.
export const PB = new InjectionToken<string>('_pb');

// Resolve an ng1 service by name from the upgraded $injector, exposed under `token`.
const fromNg1 = (token: unknown, ng1Name: string): Provider => ({
    provide: token,
    useFactory: (i: any) => i.get(ng1Name),
    deps: ['$injector'],
});

export const UPGRADE_PROVIDERS: Provider[] = [
    fromNg1(NG1_MD5, 'md5'),
    fromNg1(NG1_UIB_MODAL, '$uibModal'),
    { provide: PB, useValue: _pb },
];
